import { Text } from 'react-native'
import { useTranslation } from 'react-i18next'

import { Button, ModalBody, ModalFooter, ModalHeader, ModalTitle, useModal } from '@/components/base'

function CancelModal({ onSubmit }: { onSubmit: () => void }) {
  const { t } = useTranslation()
  const { closeModal } = useModal()

  function handleSubmit() {
    closeModal()
    onSubmit()
  }
  return (
    <>
      <ModalHeader className={'p-4'}>
        <ModalTitle>{t('orders:cancelOrder')}</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <Text className={'text-sm text-text-secondary'}>{t('orders:confirmCancelOrder')}</Text>
      </ModalBody>
      <ModalFooter>
        <Button className={'flex-1'} variant={'outline'} size={'md'} onPress={closeModal}>
          {t('orders:back')}
        </Button>
        <Button className={'flex-1'} size={'md'} onPress={handleSubmit}>
          {t('orders:confirmCancel')}
        </Button>
      </ModalFooter>
    </>
  )
}

export default CancelModal
